function filterMoney(value) {
  const val = (value / 1).toFixed(2).replace('.', ',');
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".").slice(0, -3);
}
export default filterMoney;
